import { Module } from 'vuex-smart-module';
import SoftwareLicensesActions from './actions';
import SoftwareLicensesGetters from './getters';
import SoftwareLicensesMutations from './mutations';
import SoftwareLicensesState from './state';

export default new Module({
  state: SoftwareLicensesState,
  mutations: SoftwareLicensesMutations,
  actions: SoftwareLicensesActions,
  getters: SoftwareLicensesGetters,
});
